export const waitTimeList = [
  { id: "UNDER_10_MIN", name: "<10 min" },
  { id: "TEN_TO_20_MIN", name: "10-20 min" },
  { id: "TWENTY_TO_30_MIN", name: "20-30 min" },
  { id: "OVER_30_MIN", name: ">30 min" },
];

export const reservationsList = [
  { id: "Phone", name: "Phone" },
  { id: "Website", name: "Website" },
  { id: "App", name: "App" },
  { id: "In-person", name: "In-person" },
];

export const priceLevelList = [
  { id: 1, name: "$" },
  { id: 2, name: "$$" },
  { id: 3, name: "$$$" },
  { id: 4, name: "$$$$" },
];

export const NO_DRESS_CODE_PHRASE = "no dress code";
